import React from "react";

export const GlobeIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c2.5 2.5 3.8 5.7 3.8 9s-1.3 6.5-3.8 9c-2.5-2.5-3.8-5.7-3.8-9S9.5 5.5 12 3z" strokeLinecap="round" />
  </svg>
);

export const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2">
    <path d="M9 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DocIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M7 3.5h7l4 4V20a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1z" strokeLinejoin="round" />
    <path d="M14 3.5V8h4" strokeLinejoin="round" />
    <path d="M8.5 12.5h7M8.5 15.5h7M8.5 18h4" strokeLinecap="round" />
  </svg>
);

export const ChevronRightIcon = ({ className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    className={`onboarding__chevron ${className}`.trim()}
  >
    <path d="M9 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CheckIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4">
    <circle cx="12" cy="12" r="10" fill="currentColor" stroke="none" opacity="0.12" />
    <path d="M7.5 12.5l3 3 6-6.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CheckOnlyIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.6">
    <path d="M6 12.5l4 4 8-9" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ClockIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3.2 2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SparkleIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
    <path d="M11 3l1.4 4.6L17 9l-4.6 1.4L11 15l-1.4-4.6L5 9l4.6-1.4L11 3z" />
    <path d="M18 13l.8 2.2L21 16l-2.2.8L18 19l-.8-2.2L15 16l2.2-.8L18 13z" />
  </svg>
);

export const StarIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.3-4.1 5.9-.9L12 3.5z" strokeLinejoin="round" />
  </svg>
);

export const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M12 3.5l7 2.7v5.3c0 4.5-3 7.8-7 9-4-1.2-7-4.5-7-9V6.2l7-2.7z" strokeLinejoin="round" />
  </svg>
);

export const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path
      d="M6.5 4h2.2l1.2 3.5-1.6 1.4a11 11 0 0 0 4.8 4.8l1.4-1.6L18 13.3v2.2c0 1.1-1 2-2.1 1.8A15 15 0 0 1 4.7 6.1C4.5 5 5.4 4 6.5 4z"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

export const MailIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
    <path d="M4 6.5l8 6.5 8-6.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const EyeIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z" strokeLinejoin="round" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const EyeOffIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path
      d="M3.5 3.5l17 17M9.9 5.3A10.4 10.4 0 0 1 12 5c6.4 0 10 7 10 7a17.6 17.6 0 0 1-3.5 4.5M6.6 6.6C4 8.3 2 12 2 12s3.6 7 10 7c1.3 0 2.5-.3 3.6-.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 12h5.5a5.5 5.5 0 1 1-1.8-6.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const MicrosoftIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
    <rect x="3" y="3" width="8" height="8" />
    <rect x="13" y="3" width="8" height="8" />
    <rect x="3" y="13" width="8" height="8" />
    <rect x="13" y="13" width="8" height="8" />
  </svg>
);

export const LockIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="5.5" y="10.5" width="13" height="9" rx="1.6" />
    <path d="M8.5 10.5V7.8a3.5 3.5 0 0 1 7 0v2.7" strokeLinecap="round" />
  </svg>
);

export const CodeIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M9 8l-4.5 4L9 16M15 8l4.5 4L15 16" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SlidersIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M4 7h9M17 7h3M4 17h3M11 17h9" strokeLinecap="round" />
    <circle cx="14.5" cy="7" r="2.2" />
    <circle cx="8" cy="17" r="2.2" />
  </svg>
);

export const UploadIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M12 15V4M12 4l-4 4M12 4l4 4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.5 15v3.5a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V15" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CloseIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4">
    <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
  </svg>
);

export const SmileyIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="9" />
    <circle cx="9" cy="10.5" r="1" fill="currentColor" stroke="none" />
    <circle cx="15" cy="10.5" r="1" fill="currentColor" stroke="none" />
    <path d="M8.5 14c1 1.2 2.2 1.8 3.5 1.8s2.5-.6 3.5-1.8" strokeLinecap="round" />
  </svg>
);

export const PersonIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="8.5" r="3.5" />
    <path d="M4.5 19.5c1.4-3.3 4.2-5 7.5-5s6.1 1.7 7.5 5" strokeLinecap="round" />
  </svg>
);

export const InfoIcon = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5.5" strokeLinecap="round" />
    <circle cx="12" cy="8" r="0.15" fill="currentColor" stroke="currentColor" strokeWidth="1.2" />
  </svg>
);

export const RobotIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.7">
    <rect x="5" y="8.5" width="14" height="10" rx="3" />
    <path d="M12 8.5V5.5" strokeLinecap="round" />
    <circle cx="12" cy="4" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="9.3" cy="13.2" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="14.7" cy="13.2" r="1.1" fill="currentColor" stroke="none" />
    <path d="M9.5 16.3h5" strokeLinecap="round" />
    <path d="M3.5 12v3M20.5 12v3" strokeLinecap="round" />
  </svg>
);

export const KebabIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
    <circle cx="12" cy="5.5" r="1.6" />
    <circle cx="12" cy="12" r="1.6" />
    <circle cx="12" cy="18.5" r="1.6" />
  </svg>
);

export const SendIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M4 12l16-7-6.5 16-2.7-6.8L4 12z" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DesktopIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3.5" y="5" width="17" height="11" rx="1.5" />
    <path d="M9 20h6M12 16v4" strokeLinecap="round" />
  </svg>
);

export const MobileIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="7.5" y="3" width="9" height="18" rx="2" />
    <path d="M11.2 18.2h1.6" strokeLinecap="round" />
  </svg>
);

export const PencilIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path
      d="M14.5 5.5l4 4L8 20H4v-4l10.5-10.5z"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

export const BoltIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M12.5 3L5 13.5h5.5L11 21l7.5-10.5H13L12.5 3z" strokeLinejoin="round" strokeLinecap="round" />
  </svg>
);

export const CopyIcon = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M6 15H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1" strokeLinecap="round" />
  </svg>
);

export const EnvelopeIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
    <path d="M4 6.5l8 6.5 8-6.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DiamondIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
    <rect x="6" y="6" width="12" height="12" rx="2" transform="rotate(45 12 12)" />
  </svg>
);

export const RefreshIcon = ({ className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    className={className}
  >
    <path
      d="M4.5 12a7.5 7.5 0 0 1 12.6-5.5M19.5 12a7.5 7.5 0 0 1-12.6 5.5"
      strokeLinecap="round"
    />
    <path d="M17 3.5V7h-3.5M7 20.5V17h3.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const RocketIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path
      d="M12 3c2.8 1.2 4.5 3.9 4.5 8 0 1.8-.4 3.3-1 4.5l-3.5 2-3.5-2c-.6-1.2-1-2.7-1-4.5 0-4.1 1.7-6.8 4.5-8z"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="10" r="1.6" />
    <path d="M8.5 15L6 15.5 5.5 19 8.5 17.5M15.5 15l2.5.5.5 3.5-3-1.5" strokeLinejoin="round" strokeLinecap="round" />
  </svg>
);

export function formatFileSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
